import { render, staticRenderFns } from "./Log_Info_View.vue?vue&type=template&id=5920c22c&"
import script from "./Log_Info_View.vue?vue&type=script&lang=js&"
export * from "./Log_Info_View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports